import { render, staticRenderFns } from "./add-import-program-modal.vue?vue&type=template&id=415de63d&scoped=true"
import script from "./add-import-program-modal.vue?vue&type=script&lang=js"
export * from "./add-import-program-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415de63d",
  null
  
)

export default component.exports